import * as yup from "yup";
import { BASIC_AUTHENTICATION_ERROR } from "../constants/errorMessages";
import REGEX from "../constants/constants";

const { EMAIL_PATTERN } = REGEX;

export const forgetPasswordSchema = yup.object({
  email: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.MSG_EMAIL_USERNAME_REQ)
    .matches(EMAIL_PATTERN, BASIC_AUTHENTICATION_ERROR.EMAIL)
    .max(254, BASIC_AUTHENTICATION_ERROR.MSG_EMAIL_LENGTH),
});

export const resetPasswordSchema = yup.object({
  newPassword: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.MSG_REQUIRED_PASSWORD)
    .min(8, BASIC_AUTHENTICATION_ERROR.MSG_PASSWORD_TYPE),
  confirmPassword: yup
    .string()
    .required(BASIC_AUTHENTICATION_ERROR.MSG_REQUIRED_PASSWORD)
    .min(8, BASIC_AUTHENTICATION_ERROR.MSG_PASSWORD_TYPE)
    .test('passwords-match', 'Passwords must match', function(value) {
      return !value || value === this.parent.newPassword;
    }),
});
